import { Component } from "react";
import Paper from "@material-ui/core/Paper";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import globalsCss from "../../common/styles/globals.css";

class LoggedOut extends Component {
    render() {
        return (
            <Paper elevation={1}>
                <div css={globalsCss.inner}>
                    <h3>You have signed out of your account</h3>
                    <p>Its a good idea to close all browser windows</p>
                </div>
            </Paper>
        );
    }
}

export default LoggedOut;
